import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { InvoicePeerService } from '../../service/invoice-peer.service';
import { PcrService } from '../../api/services';
import { Invoice, PcrReportingTask } from '../../api/models';

@Component({
  selector: 'app-invoice-pcr-widget',
  templateUrl: './invoice-pcr-widget.component.html',
  styleUrls: ['./invoice-pcr-widget.component.scss']
})
export class InvoicePcrWidgetComponent implements OnInit, OnDestroy {
  private readonly ngDestroy$ = new Subject<void>();

  invoice: Invoice;
  tasks$: Observable<PcrReportingTask[]>;
  selectedTask: PcrReportingTask | null = null;

  constructor(
    private invoicePeerService: InvoicePeerService,
    private pcrService: PcrService
  ) {}

  ngOnInit(): void {
    this.invoicePeerService.getInvoice()
      .pipe(
        takeUntil(this.ngDestroy$),
        filter(invoice => !!invoice)
      )
      .subscribe(invoice => {
        this.invoice = invoice;
        if (invoice.is_pcr_reportable) {
          this.tasks$ = this.pcrService.listInvoicePcrReportingHistory({ id: invoice.id }).pipe(
            map((result) => (Array.isArray(result?.items) ? result.items : []))
          );
        } else {
          this.tasks$ = null;
        }
      });
  }

  ngOnDestroy(): void {
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  selectTask(task: PcrReportingTask): void {
    this.selectedTask = this.selectedTask === task ? null : task;
  }
}
